import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as utils from '../../../../../utils';
import DaySelect from './DaySelect';
import { setStartDayId, daySelectSwitch } from '../../../../../redux/actions';
import { IS_TEST, YEAR } from '../../../../../constants';

class DaySelectContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthActual: utils.getDateByDayId(props.currentDayId).getMonth(),
      monthMax: IS_TEST ? 11 : utils.getDateByDayId(props.endDayId).getMonth()
    };

    this.handleOpenList = this.handleOpenList.bind(this);
    this.handleMonthSwapPrev = this.handleMonthSwapPrev.bind(this);
    this.handleMonthSwapNext = this.handleMonthSwapNext.bind(this);
    this.handleDaySelect = this.handleDaySelect.bind(this);
  }

  // -------------------------------------------------------
  // Handlers
  // -------------------------------------------------------

  handleOpenList() {
    this.props.daySelectSwitch(!this.props.daySelectOpen);
  }

  handleDaySelect(day) {
    const dayId = utils.getDayIdByDate(
      new Date(YEAR, this.state.monthActual, day)
    );
    if (dayId !== this.props.startDayId) {
      this.props.setStartDayId(dayId);
    }
  }

  handleMonthSwapPrev() {
    this.setState({
      monthActual: Math.max(this.state.monthActual - 1, 0)
    });
  }

  handleMonthSwapNext() {
    this.setState({
      monthActual: Math.min(this.state.monthActual + 1, this.state.monthMax)
    });
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { monthActual, monthMax } = this.state;
    const { endDayId, startDayId, daySelectOpen, columns } = this.props;

    const currentMonthLength = new Date(YEAR, monthActual + 1, 0).getDate();
    const monthStartDay = new Date(YEAR, monthActual, 1).getDay();
    const monthStartDayId = monthStartDay === 0 ? 6 : monthStartDay - 1;
    const endDayDate = utils.getDateByDayId(endDayId);

    // set days data
    const daysData = [];
    for (let i = 0; i < monthStartDayId + currentMonthLength; i += 1) {
      const day = i + 1 - monthStartDayId;
      const active = monthActual < monthMax || day <= endDayDate.getDate();
      const dayId = active
        ? utils.getDayIdByDate(new Date(YEAR, monthActual, day))
        : -1;
      daysData.push({
        id: `${monthActual}-${i}`,
        day,
        sunday: (i + 1) % 7 === 0,
        active,
        actual: dayId >= startDayId && dayId < startDayId + columns
      });
    }

    return (
      <DaySelect
        monthId={monthActual}
        daysData={daysData}
        onOpenList={this.handleOpenList}
        prevActive={monthActual > 0}
        nextActive={monthActual < monthMax}
        onMonthSwapPrev={this.handleMonthSwapPrev}
        onMonthSwapNext={this.handleMonthSwapNext}
        onDaySelect={this.handleDaySelect}
        daySelectOpen={daySelectOpen}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentDayId: state.navigation.currentDayId,
  startDayId: state.navigation.startDayId,
  endDayId: state.navigation.endDayId,
  columns: state.navigation.columns,
  daySelectOpen: state.navigation.daySelectOpen
});

const mapDispatchToProps = dispatch => ({
  setStartDayId: startDayId => dispatch(setStartDayId(startDayId)),
  daySelectSwitch: show => dispatch(daySelectSwitch(show))
});

DaySelectContainer.propTypes = {
  currentDayId: PropTypes.number.isRequired,
  startDayId: PropTypes.number.isRequired,
  columns: PropTypes.number.isRequired,
  endDayId: PropTypes.number.isRequired,
  daySelectOpen: PropTypes.bool.isRequired,
  setStartDayId: PropTypes.func.isRequired,
  daySelectSwitch: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(DaySelectContainer);



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/DaySelect/DaySelectContainer.js